export default __webpack_public_path__ + "static/media/no-V5.c5d39648.svg";